import { __decorate } from "tslib";
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { WebClientService } from '../../services/webclient-settings.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
/**
 * Side Menu Fee Component
 */
let SideMenuFeeComponent = class SideMenuFeeComponent {
    constructor(webSettingsService, sanitizer, themeService) {
        this.webSettingsService = webSettingsService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.accentColor = '';
        this.themeService.getTheme().subscribe((data) => {
            if (data) {
                this.accentColor = this.themeService.getStyleAttribute('accent_color');
            }
        });
    }
};
SideMenuFeeComponent.ctorParameters = () => [
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
__decorate([
    Input()
], SideMenuFeeComponent.prototype, "provision", void 0);
__decorate([
    Input()
], SideMenuFeeComponent.prototype, "guest", void 0);
SideMenuFeeComponent = __decorate([
    Component({
        selector: 'ecd-side-menu-fee',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./side-menu-fee.component.html")).default
    })
], SideMenuFeeComponent);
export { SideMenuFeeComponent };
